var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarChange = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M23.66 30.78a1.7 1.7 0 0 1 1.7-1.7h15.96a1.7 1.7 0 1 1 0 3.4H25.36a1.7 1.7 0 0 1-1.7-1.7",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M35.196 24.68a1.7 1.7 0 0 1 2.404-.005l4.92 4.9a1.7 1.7 0 1 1-2.399 2.41l-4.92-4.9a1.7 1.7 0 0 1-.005-2.405",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M42.523 29.578a1.7 1.7 0 0 1 0 2.404l-4.92 4.92a1.7 1.7 0 0 1-2.404-2.404l4.92-4.92a1.7 1.7 0 0 1 2.404 0",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M23.66 41.38a1.7 1.7 0 0 1 1.7-1.7h15.96a1.7 1.7 0 1 1 0 3.4H25.36a1.7 1.7 0 0 1-1.7-1.7",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M24.159 40.178a1.7 1.7 0 0 1 2.404 0l4.92 4.92a1.7 1.7 0 0 1-2.404 2.404l-4.92-4.92a1.7 1.7 0 0 1 0-2.404",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M31.485 35.28a1.7 1.7 0 0 1-.005 2.405l-4.92 4.9a1.7 1.7 0 0 1-2.399-2.41l4.92-4.9a1.7 1.7 0 0 1 2.404.006",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M9.14 8.42c-1.16 0-2.1.938-2.1 2.1v23.5c0 1.16.94 2.1 2.1 2.1h9.08a1.7 1.7 0 1 1 0 3.4H9.14a5.5 5.5 0 0 1-5.5-5.5v-23.5c0-3.04 2.462-5.5 5.5-5.5h29.74c3.04 0 5.5 2.46 5.5 5.5v12.02a1.7 1.7 0 1 1-3.4 0V10.52c0-1.162-.938-2.1-2.1-2.1z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.64 17.14a1.7 1.7 0 0 1 1.7-1.7h37.32a1.7 1.7 0 1 1 0 3.4H5.34a1.7 1.7 0 0 1-1.7-1.7",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.42 0a1.7 1.7 0 0 1 1.7 1.7v10.28a1.7 1.7 0 1 1-3.4 0V1.7a1.7 1.7 0 0 1 1.7-1.7",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M32.58 0a1.7 1.7 0 0 1 1.7 1.7v10.28a1.7 1.7 0 1 1-3.4 0V1.7a1.7 1.7 0 0 1 1.7-1.7",
  clipRule: "evenodd"
})));
export default SvgCalendarChange;